<div class="authPage">
  <div class="authFormPane">
    <a class="authLogo" routerLink="/login">
      <div class="logoBox"><img src="assets/img/icons/envision-menu-72px.png" alt="Urbanhub"></div>
      <span class="logoText"><b>Urban</b>hub</span>
    </a>

    <div class="authFormContent">
      @if (stepper === 0) {
        <div>
          <a class="authLink authReturn" routerLink="../login">{{ 'GENERAL.RETURN_LOGIN' | translate }}</a>
          <h1 class="authTitle">{{ 'FORGOT.TITLE' | translate }}</h1>
          <p class="authSubtitle">{{ 'FORGOT.EXTRA_SUBTITLE' | translate }}</p>
        </div>

        <form class="authForm" [formGroup]="form" (ngSubmit)="submit()">
          <div class="authField">
            <label for="forgotMail">{{ 'FORGOT.MAIL' | translate }}</label>
            <mat-form-field appearance="outline" class="customMatFormField">
              <input id="forgotMail" type="email" matInput formControlName="mail" autocomplete="email">
            </mat-form-field>
          </div>

          @if (errorInRequest) {
            <mat-error>
              {{ 'ERROR.BAD_REQUEST' | translate }}
            </mat-error>
          }
          @if (!this.correctInput) {
            <mat-error>
              {{ 'ERROR.WRONG_CREDENTIALS' | translate }}
            </mat-error>
          }

          <button id="sendButton" type="submit" mat-flat-button class="actionButton authSubmit" [disabled]="isLoading">
            @if (isLoading) {
              <span class="material-icons rotating">
                loop
              </span>
            }
            {{ 'FORGOT.SEND' | translate }}
          </button>
        </form>
      }

      @if (stepper === 1) {
        <div>
          <a class="authLink authReturn" routerLink="../login">{{ 'GENERAL.RETURN_LOGIN' | translate }}</a>
          <h1 class="authTitle">{{ 'FORGOT.CHECK_TITLE' | translate }}</h1>
          <p class="authSubtitle">{{ 'FORGOT.CHECK' | translate }}</p>
        </div>
      }
    </div>
  </div>

  <div class="authVisualPane">
    <img class="authCityImg" src="assets/img/auth/city-square-light.png" alt="">
  </div>
</div>
